import { actionTypes as types } from '../constants'
import { errorCodes } from 'universal'

const initialState = {
  // isFetching is used to determine whether data is available
  isFetching: false,
  // Save lock/unlock success action
  fetchSuccessAction: '',

  /* error handling */
  // this is true when api responds successfully but response contains errors
  hasUnlockContingency: false,
  // this is true on api failure
  fetchError: null,
  hasRiskStepUp: false,
  stepUpContext: [],
}

const fetchingState = () => ({
  ...initialState,
  isFetching: true,
})

const successState = (action) => ({
  ...initialState,
  fetchSuccessAction: action.type,
})

const failureState = (action) => ({
  ...initialState,
  fetchError: action.fetchError,
})

const reactivateSuccessStateSubErrors = ({ card, applyForReactivateResult }) => {
  if (card) {
    return {}
  }

  if (applyForReactivateResult?.errorStatus === errorCodes.STEPUP_AUTH) {
    return {
      hasRiskStepUp: true,
      stepUpContext: applyForReactivateResult?.stepUpContext,
    }
  }

  return {
    hasUnlockContingency: true,
  }
}

function lockPanel(state = initialState, action = {}) {
  switch (action.type) {
    case types.DEACTIVATE_CARD:
    case types.REACTIVATE_CARD:
      return {
        ...state,
        ...fetchingState(),
      }

    case types.DEACTIVATE_CARD_SUCCESS:
      return {
        ...state,
        ...successState(action),
      }

    case types.REACTIVATE_CARD_SUCCESS:
      return {
        ...state,
        ...successState(action),
        ...reactivateSuccessStateSubErrors(action),
      }

    case types.DEACTIVATE_CARD_FAILURE:
    case types.REACTIVATE_CARD_FAILURE:
      return {
        ...state,
        ...failureState(action),
      }

    // the purpose of this is to remove ONLY blocking toast/spinners/shimmers/errors/retries
    // TODO rename to indicate intent to something like "reset fetch-related loaders and errors"
    case types.RESET_CARD_REQUEST:
      return {
        ...state,
        ...initialState,
      }

    default:
      return state
  }
}

export default lockPanel
